/* eslint-disable @typescript-eslint/no-explicit-any */
import ImageOptimize from '@/components/ImageOptimize'
import { labelPositionProductCard } from '@/constants/positions'
import type { LabelProduct } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'

export interface ProductProps {
  labels: LabelProduct[]
}

const ProductCardLabels = ({ labels }: ProductProps) => {
  return (
    <>
      {labels?.map((item, index) => (
        <span
          className={`${labelPositionProductCard.get(
            item.position
          )} label absolute flex h-auto w-full flex-nowrap gap-x-2 overflow-x-auto overflow-y-hidden scrollbar-hide`}
          key={item.image}
          style={{ zIndex: 50 + index }}
        >
          <ImageOptimize
            src={item.image}
            alt={getTranslate(item.name)}
            width={200}
            height={48}
            loading='lazy'
            className={`h-auto w-full`}
          />
        </span>
      ))}
    </>
  )
}

export default ProductCardLabels
